import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for AddorEditList  trade setup
export const AddorEditList = createSlice({
  name: "AddorEditList",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_AddorEditList: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_AddorEditList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_AddorEditList: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    AddorEditList_is_first: (state, action) => {
      state.isFirst = false;
    },
    clearData: (state) => {
      state.data = [];
    },
  },
});
export default AddorEditList.reducer;
export const {
  list_AddorEditList,
  success_api_call_AddorEditList,
  failure_api_call_AddorEditList,
  AddorEditList_is_first,
  clearData,
} = AddorEditList.actions;
